import React from 'react'

import { ResearchVisual } from '@/components/announcements/DiscoveryIntroModal/visuals'

export const DeepResearchPreview: React.FC = () => (
  <figure className="relative my-6 h-[194px] overflow-hidden rounded-xl border border-primary-200 bg-gradient-to-b from-accent-400/15 via-violet-500/[0.06] to-transparent dark:border-primary-800">
    <ResearchVisual />
    <figcaption className="sr-only">
      A Deep Research run splitting a question into research tasks, reviewing
      federal awards and company sources, and compiling a cited brief.
    </figcaption>
  </figure>
)

export default DeepResearchPreview
